import * as informationvideos from '@appStore/learning/actions/information-videos.actions';

export * from '@appStore/learning/actions/information-videos.actions';

export const ActionTypes = { 
    ...informationvideos.InformationVideosActionTypes
};

export type Actions = 
informationvideos.InformationVideosActions;
